/*
 * Wmb, Worldline Merchant Billing.
 * Copyright (C) 2017-2019 Worldline
 * All Rights Reserved
 * This product is protected by copyright. Any copying or distribution
 * is forbidden without the agreement of Worldline.
 */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { ConfigurationService } from 'app/core/services/configuration.service';
import { AuthenticatedRouteGuard } from './authenticatedRouteGuard.service';
import { AuthentificationErrorResponseInterceptor } from './authentification-errorresponse-interceptor.service';
import { AuthentificationInterceptor } from './authentification-interceptor.service';
import { KeycloakService } from './keycloak.service';


export function initializeKeycloak(keycloak: KeycloakService, configService: ConfigurationService) {
    return () => configService.load().then(
        () => {
            keycloak.initialize();
        });
}

@NgModule({
    providers: [
        KeycloakService,
        AuthenticatedRouteGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthentificationInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthentificationErrorResponseInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService, ConfigurationService]
        },
    ]
})
export class SecurityModule {
}
